import Phaser from "phaser";
import { loadBetterCrtShader } from "./effects/crt.js";
import type { AppData } from "./types.js";
import { COLORS, FONT, FONT_SIZE, FONT_SIZE_BANNER, GAME_HEIGHT, GAME_WIDTH } from "./terminal/constants.js";
import { TerminalScene } from "./terminal/terminal-scene.js";

function readAppData(): AppData | null {
    const node = document.getElementById("app-data");
    if (!node?.textContent) return null;
    return JSON.parse(node.textContent) as AppData;
}

async function startApp(): Promise<void> {
    const appData = readAppData();
    if (!appData) return;

    await document.fonts.load(`${FONT_SIZE}px VT323`);
    await document.fonts.load(`${FONT_SIZE_BANNER}px VT323`);
    await loadBetterCrtShader();

    new Phaser.Game({
        type: Phaser.AUTO,
        parent: "game",
        backgroundColor: COLORS.bg,
        scale: {
            mode: Phaser.Scale.FIT,
            autoCenter: Phaser.Scale.CENTER_BOTH,
            width: GAME_WIDTH,
            height: GAME_HEIGHT,
        },
        scene: [TerminalScene],
        callbacks: {
            preBoot: (bootGame: Phaser.Game) => {
                bootGame.registry.set("appData", appData);
            },
        },
    });
}

void startApp();
